import { Modal, Button } from "react-bootstrap";

function ErrorModal(props: { error: string; onHide: () => void }) {
  return (
    <Modal
      {...props}
      show={props.error && props.error.length > 0}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <h3>Error</h3>
      </Modal.Header>
      <Modal.Body>
        <span>{props.error}</span>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ErrorModal;
